import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { MainContext } from "../../contexts/main";
import { getText } from '@educaplay/app-core/language';
import { getURL, navigateTo } from "../../helpers/urls";
import config from "../../resources/config.json";
import { SVG_check, SVG_invoice, SVG_star } from "../elements/SVG";
import { TeamPlanContact } from "./TeamPlanContact";
import { BlockPricesPromo } from "./BlockPricesPromo";
import { getVolumeDiscount } from "../../helpers/billing";

import { BlockInfoPlan } from "./BlockInfoPlan";
import { useActiveLicense } from "../../hooks/useActiveLicense";

export const BlockPlan = ({ id, disablePeriodicity, teamPlanClick }) => {
  const { environment, mainReducer, appReducer } = useContext(MainContext);
  const navigate = useNavigate();

  const state = mainReducer.state;
  const { activeLicense } = useActiveLicense();

  const handleOnChangePeriodicity = ({ target }) => {
    mainReducer.dispatch({
      type: "changePeriodicity",
      payload: target.value,
    });
  };

  const handleOpenBudget = () => {
    if (state.selectedLicense.licenses > config.maxLicenses) return;

    mainReducer.dispatch({
      type: "changeIdLicense",
      payload: id,
    });

    appReducer.dispatch({
      type: "openModal",
      payload: { id: "budget" },
    });
  };

  const handleSelectPlan = () => {
    if (state.selectedLicense.licenses > config.maxLicenses) {
      teamPlanClick();
      return;
    }

    mainReducer.dispatch({
      type: "changeIdLicense",
      payload: id,
    });

    navigateTo("premiumCheckout", navigate, environment, appReducer);
  };

  const planDiscount = getVolumeDiscount(
    state.selectedLicense.licenses,
    state.currency.code,
    id,
    state.discounts,
  );

  return (
    <>
      {(id != 0 || state.user === false || activeLicense.id === 0) && (
        <article
          className={`e__plns__lst__plan e__plns__lst__plan--${id}${
            config.plans[id].highlight ? " e__plns__lst__plan--highlight" : ""
          }${activeLicense.id == id
              ? " e__plns__lst__plan--selected"
              : ""
          }`}
        >
          <div className="e__plns__hdg__hd e__plns__hdg__hd--column">
            <div className="flex align-end">
            <span className="e__plns__hdg__hd__ico">
              <SVG_star />
            </span>
            <div className="e__plns__hdg__hd__main">
              <div className="e__plns__hdg__hd__shdg">
                {getText("plan_educaplay")}
              </div>
              <div className="e__plns__hdg__hd__wrp">
                <span className="e__plns__hdg__hd__hdg">
                  {getText("plan_name_" + id)}
                </span>
              </div>
            </div>  
            </div>  
            <BlockInfoPlan id={id} />
          </div>
      

          {id != 0 && (
            <div className="e__plns__lst__plan__slct">
              <div className="e__slct e__slct--min">
                <label htmlFor={`plan_${id}_periodicity`}>
                  {getText("periodicidad")}:
                </label>
                <select
                  id={`plan_${id}_periodicity`}
                  onChange={handleOnChangePeriodicity}
                  value={state.selectedLicense.periodicity}
                  disabled={disablePeriodicity}
                >
                  {Object.keys(config.periodicities).map((periodicity) => (
                    <option key={periodicity} value={periodicity}>
                      {getText("periodicity_" + periodicity)}
                    </option>
                  ))}
                </select>
              </div>

              {state.selectedLicense.periodicity == config.defaultPeriodicity && (
                  <span className="e__plns__dscount">
                    <span className="e__plns__dscount__nmbr">
                      {state.discountForPeriodicity[id][
                        state.selectedLicense.periodicity
                      ] + "%"}
                    </span>
                    {getText("porcentaje_ahorro_por_periodicidad")}
                  </span>
                )}
            </div>
          )}

          <div className="e__plns__lst__plan__info">
            {config.plans[id].advantages.map((element, index) => (
              <div key={index} className="e__plns__lst__plan__info__item">
                <span className="e__plns__lst__plan__info__item__ico">
                  <SVG_check />
                </span>
                <span className="e__plns__lst__plan__info__item__txt">
                  {getText("advantage_" + id + "_" + element)}
                </span>
              </div>
            ))}

            {state.selectedLicense.licenses > 1 &&
              config.plans[id].advantagesTeamPlan?.map((element, index) => (
                <div key={index} className="e__plns__lst__plan__info__item">
                  <span className="e__plns__lst__plan__info__item__ico">
                    <SVG_check />
                  </span>
                  <span className="e__plns__lst__plan__info__item__txt">
                    {getText("advantage_team_" + element)}
                  </span>
                </div>
              ))}
          </div>

          {id == 0 ? (
            <div className="e__plns__lst__plan__btns">
              {state.user === false ? (
                <a
                  className="e-btn e-btn--secondary"
                  href={
                    getURL(environment, "signup") +
                    (environment.showConsent == "no" ? "?showConsent=no" : "")
                  }
                >
                  <span className="e__btn__txt">
                    {getText("registrate_button")}
                  </span>
                </a>
              ) : (
                <span className="e__txt">{getText("plan_contratado")}</span>
              )}
            </div>
          ) : (
            <>
              {state.selectedLicense.licenses <= config.maxLicenses ? (
                <>
                  <BlockPricesPromo licenseId={id} planDiscount={planDiscount} />
                  <div className="e__plns__lst__plan__btns">
                    {activeLicense.periodicity ==
                      state.selectedLicense.periodicity &&
                    activeLicense.licenses ==
                      state.selectedLicense.licenses &&
                    activeLicense.id == id ? (
                      <span className="e__txt">
                        {getText("plan_contratado")}
                      </span>
                    ) : (
                      <>
                        <button
                          className="e-btn e-btn--transparent"
                          onClick={handleOpenBudget}
                          type="button"
                        >
                          <span>
                            <SVG_invoice />
                          </span>
                          <span className="e__btn__txt">
                            {getText("presupuesto")}
                          </span>
                        </button>

                        <button
                          className="e-btn e-btn--lg e-btn--premium"
                          onClick={handleSelectPlan}
                          type="button"
                        >
                          <span className="e__btn__txt">
                            {getText(
                              state.inProgressLicense.id == 0
                                ? "elegir"
                                : "cambiar_suscripcion",
                            )}
                          </span>
                        </button>
                      </>
                    )}
                  </div>
                </>
              ) : (
                <TeamPlanContact
                  planId={id}
                  numPlans={state.selectedLicense.licenses}
                  handleOpenTeamPlan={teamPlanClick}
                />
              )}
            </>
          )}
        </article>
      )}
    </>
  );
};
